import { useState } from "react";
import { Helmet } from "react-helmet";
import BackButton from "../components/BackButton";

export default function WebsiteScreenshot() {
  const [url, setUrl] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [apiKey] = useState("YOUR_API_KEY_HERE"); // Replace with your actual key

  const handleGenerate = () => {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      alert("Please enter a valid URL with http or https");
      return;
    }

    const encodedUrl = encodeURIComponent(url);
    const screenshotUrl = `https://api.screenshotmachine.com?key=${apiKey}&url=${encodedUrl}&dimension=1024xfull`;

    setImageUrl(screenshotUrl);
  };

  const handleDownload = async () => {
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `screenshot_${Date.now()}.jpg`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      alert("Failed to download image.");
    }
  };

  return (
    <>
      <Helmet>
        <title>Website Screenshot Generator - Free Online Tool</title>
        <meta
          name="description"
          content="Instantly capture full-page screenshots of any website for free. Simply enter the URL to generate a website preview image online."
        />
        <meta
          name="keywords"
          content="website screenshot generator, website preview, screenshot tool, free website screenshot, full-page screenshot, online screenshot generator"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://freelity.com/website-screenshot-generator" />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container">
          <BackButton />
          <h2>Website Screenshot Generator</h2>

          <input
            type="text"
            className="form-control mb-3"
            placeholder="Enter website URL (https://...)"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
          />

          <button className="btn btn-primary mb-4" onClick={handleGenerate}>
            Get Screenshot
          </button>

          {imageUrl && (
            <div className="text-center">
              <img src={imageUrl} alt="Website Screenshot" className="img-fluid mb-3" />
              <button className="btn btn-success" onClick={handleDownload}>
                Download Screenshot
              </button>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
